export function isHeicAsset(name: string, type = '') {
  return /\.(heic|heif)(?:[?#]|$)/i.test(name) || /^image\/hei[cf](?:-sequence)?$/i.test(type);
}
